<template>
  <div
    class="subscene"
    :style="{zIndex: scene.pos.zIndex, left: `${scene.pos.x}%`, top: `${scene.pos.y}%`}"
  >
    <img :src="this.scene.imageSmall" alt="tile" />
  </div>
</template>

<script>
export default {
  name: "subscene",

  props: {
    scene: Object
  },
};
</script>

<style lang="scss" scoped>
.subscene {
  position: absolute;
  will-change: transform;
  transition: transform 0.3s;

  img {
    will-change: transform;
    transition: transform 0.3s;
    min-width: 450px;
    max-width: 870px;
    // width: 450px;
  }
}
</style>
